export default "__VITE_ASSET__DcHfRVWl__"